import React, { Component } from "react";
import {
  loading,
  NavbarAdmin,
  GET,
  DateRangePicker,
  t // นำเข้าฟังก์ชัน t
} from "../../components/CustomComponent.js";

// สีตาม HTML prototype ("สรุปรายงานWR_bps_report_prototype_1.html") ที่ PM แนบมาในการ์ด
const STATUS_META = [
  { id: "pending", labelKey: "pending", descKey: "wr_status_desc_pending", color: "#f59e0b", bg: "#fef3e2", valueColor: "#b3660a" },
  { id: "success", labelKey: "success", descKey: "wr_status_desc_success", color: "#16a34a", bg: "#e8f8ee", valueColor: "#16a34a" },
  { id: "pending_approval", labelKey: "pending_approval", descKey: "wr_status_desc_pending_approval", color: "#8b5cf6", bg: "#f1ecfe", valueColor: "#8b5cf6" },
  { id: "approved", labelKey: "approved", descKey: "wr_status_desc_approved", color: "#2f6fed", bg: "#e9f0ff", valueColor: "#2f6fed" },
  { id: "rejected", labelKey: "rejected", descKey: "wr_status_desc_rejected", color: "#ef4444", bg: "#fdeceb", valueColor: "#ef4444" },
];

const CATEGORY_COLORS = ["#2f6fed", "#7c5cfc", "#14b8c4", "#c3cae2", "#f59e0b", "#16a34a", "#ef4444", "#94a3b8"];
// สีของกลุ่ม "ไม่ระบุหมวดหมู่" - เทาอ่อน แยกออกจากชุดสีของหมวดหมู่จริง
const UNCATEGORIZED_COLOR = "#cbd5e1";

// เกณฑ์ SLA Fast Call ตอบสนอง — ยังไม่มี endpoint คืนค่าตั้งค่านี้แยกต่อบริษัท ใช้ 24 ชม. ตาม prototype ไปก่อน (ดู note ท้ายไฟล์)
const SLA_TARGET_HOURS = 24;

export default class WorkRequestSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_work_requests: [],
      start_date: this.getDefaultStartDate(),
      end_date: this.getDefaultEndDate(),
    };
  }

  async componentDidMount() {
    loading(true);
    // page:0 = ไม่แบ่งหน้า ได้ข้อมูลทั้งหมด (ตาม pattern ของหน้ารายงานอื่น เช่น work-order-summary.js)
    const result = await GET("admin/work-requisitions", { page: 0 });
    this.setState({
      data_work_requests: result?.status ? result.data || [] : [],
    });
    loading(false);
  }

  getDefaultStartDate = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1);
  };

  getDefaultEndDate = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth() + 1, 0);
  };

  toDateOnly = (value) => {
    if (!value) return null;
    const d = new Date(value);
    if (isNaN(d.getTime())) return null;
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  };

  getFilteredRequests = () => {
    const { data_work_requests, start_date, end_date } = this.state;
    const rangeStart = this.toDateOnly(start_date);
    const rangeEnd = this.toDateOnly(end_date || start_date);
    if (!rangeStart || !rangeEnd) return data_work_requests;

    return data_work_requests.filter((item) => {
      const createdDate = this.toDateOnly(item.created_at);
      if (!createdDate) return false;
      return createdDate >= rangeStart && createdDate <= rangeEnd;
    });
  };

  getCurrentLang = () => localStorage.getItem("lang") || "TH";

  getCustomerDisplayName = (customer) => {
    const currentLang = this.getCurrentLang();
    if (currentLang === "EN") {
      return `${customer?.customer_code || ""} ${customer?.full_name_en || customer?.full_name_th || "-"}`.trim();
    }
    return `${customer?.customer_code || ""} ${customer?.full_name_th || customer?.full_name_en || "-"}`.trim();
  };

  // หมวดหมู่เป็นตัวเลือก (ไม่บังคับ) ตอนแอดมินสร้างคำร้อง ใบที่ไม่ได้เลือกจึงถูกรวมเป็นกลุ่มเดียว
  // เดิมใช้ข้อความ "ไม่มีข้อมูล" ซึ่งอ่านแล้วเหมือนระบบดึงข้อมูลไม่ได้ ทั้งที่เป็นคำร้องที่ไม่ได้ระบุหมวดหมู่ไว้
  getCategoryLabel = (item) => item?.category?.name_th || item?.category?.name_en || t("uncategorized");

  getStatusCounts = (filtered) => {
    return STATUS_META.map((meta) => ({
      ...meta,
      label: t(meta.labelKey),
      desc: t(meta.descKey),
      count: filtered.filter((item) => String(item.status || "").trim().toLowerCase() === meta.id).length,
    }));
  };

  // เรียงตามลำดับที่ลูกค้ากำหนด (STATUS_META): รอดำเนินการ, สำเร็จ, รออนุมัติ, อนุมัติแล้ว, ปฏิเสธ
  // แล้วคำนวณ stroke-dasharray/offset ของวงกลม svg (r=15.9 → เส้นรอบวง = 100%)
  getStatusDonutSegments = (statusCounts, total) => {
    if (!total) return [];
    const sorted = statusCounts.filter((s) => s.count > 0);
    let cumulative = 0;
    return sorted.map((s) => {
      const pct = (s.count / total) * 100;
      const dashoffset = 25 - cumulative;
      cumulative += pct;
      return { ...s, pct, dashoffset };
    });
  };

  getCategoryBreakdown = (filtered) => {
    const map = new Map();
    filtered.forEach((item) => {
      const label = this.getCategoryLabel(item);
      map.set(label, (map.get(label) || 0) + 1);
    });
    return [...map.entries()]
      .map(([label, count]) => ({ label, count }))
      .sort((a, b) => b.count - a.count)
      // กลุ่ม "ไม่ระบุหมวดหมู่" ใช้สีเทา ไม่กินสีในชุดของหมวดหมู่จริง จะได้แยกออกด้วยตาว่าไม่ใช่หมวดหมู่ที่ลูกค้าเลือก
      .map((c, idx) => ({
        ...c,
        is_uncategorized: c.label === t("uncategorized"),
        color: c.label === t("uncategorized") ? UNCATEGORIZED_COLOR : CATEGORY_COLORS[idx % CATEGORY_COLORS.length],
      }));
  };

  getTopCustomers = (filtered) => {
    const map = new Map();
    filtered.forEach((item) => {
      const customer = item.customer;
      if (!customer?.uid) return;

      const entry = map.get(customer.uid) || {
        uid: customer.uid,
        name: this.getCustomerDisplayName(customer),
        assets: new Set(),
        count: 0,
      };
      entry.count += 1;
      const assetName = item.asset?.part_name || item.asset?.asset_code;
      if (assetName) entry.assets.add(assetName);
      map.set(customer.uid, entry);
    });

    return [...map.values()]
      .map((e) => ({ ...e, assetLabel: [...e.assets].slice(0, 3).join(" · ") || "-" }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 5);
  };

  // SLA Response Time: นับจากสร้างคำร้อง (created_at) ถึง Fast Call ครั้งแรก (fast_call.call_time) — ฟิลด์มีอยู่แล้วใน admin/work-requisitions
  getSlaStats = (filtered) => {
    const durations = [];
    let met = 0;

    filtered.forEach((item) => {
      const createdAt = item.created_at ? new Date(item.created_at) : null;
      const callTime = item.fast_call?.call_time ? new Date(item.fast_call.call_time) : null;
      if (!createdAt || !callTime || isNaN(createdAt.getTime()) || isNaN(callTime.getTime())) return;

      const hours = (callTime - createdAt) / 3600000;
      if (hours < 0) return;

      durations.push(hours);
      if (hours <= SLA_TARGET_HOURS) met += 1;
    });

    const total = durations.length;
    const avgHours = total ? durations.reduce((a, b) => a + b, 0) / total : null;
    const passRate = total ? (met / total) * 100 : null;

    return { total, met, exceeded: total - met, avgHours, passRate };
  };

  render() {
    const { start_date, end_date } = this.state;
    const filtered = this.getFilteredRequests();
    const total = filtered.length;

    const statusCounts = this.getStatusCounts(filtered);
    const donutSegments = this.getStatusDonutSegments(statusCounts, total);

    const categoryBreakdown = this.getCategoryBreakdown(filtered);
    const categoryMax = Math.max(1, ...categoryBreakdown.map((c) => c.count));

    const topCustomers = this.getTopCustomers(filtered);
    const customerMax = Math.max(1, ...topCustomers.map((c) => c.count));

    const slaStats = this.getSlaStats(filtered);

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3">

          {/* Header */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
            <div>
              <h3 className="fw-bold mb-1">{t("work_request_summary_report")}</h3>
              <div className="text-secondary">{t("wr_summary_desc")}</div>
            </div>
            <div className="d-flex gap-3 align-items-center">
              <div style={{ width: "260px" }}>
                <DateRangePicker
                  type="th"
                  className="form-control bg-white rounded-2 border-0 shadow-sm text-dark"
                  value={{ start_date, end_date }}
                  onChange={(range) =>
                    this.setState({
                      start_date: range.start_date,
                      end_date: range.end_date,
                    })
                  }
                />
              </div>
            </div>
          </div>

          {/* Stat cards: รวม + 5 สถานะ ตามสีของ prototype */}
          <div className="row g-3 mb-4">
            <div className="col-lg-2 col-md-4 col-6">
              <div className="card border-0 rounded-4 shadow-sm p-4 h-100 text-center" style={{ backgroundColor: "#eef1fb" }}>
                <div className="text-secondary text-14 fw-bold mb-1">{t("total_wr")}</div>
                <h1 className="fw-bold mb-0" style={{ color: "#16213e", fontSize: "2.25rem" }}>{total}</h1>
              </div>
            </div>
            {statusCounts.map((s) => (
              <div className="col-lg-2 col-md-4 col-6" key={s.id}>
                <div className="card border-0 rounded-4 shadow-sm p-4 h-100 text-center" style={{ backgroundColor: s.bg }}>
                  <div className="text-secondary text-14 fw-bold mb-1">{s.label}</div>
                  <h1 className="fw-bold mb-0" style={{ color: s.valueColor, fontSize: "2.25rem" }}>{s.count}</h1>
                </div>
              </div>
            ))}
          </div>

          {/* Row: สถานะ (donut) + หมวดหมู่ (bar) */}
          <div className="row g-4 mb-4">
            <div className="col-lg-5">
              <div className="card border-0 rounded-4 shadow-sm p-4 h-100 bg-white">
                <div className="d-flex align-items-baseline justify-content-between mb-1">
                  <h6 className="fw-bold text-dark mb-0">{t("by_status")}</h6>
                  <div className="text-secondary text-12">{total} {t("wr_count_unit")}</div>
                </div>
                <div className="text-secondary text-12 mb-3">{t("by_status_desc")}</div>

                <div className="d-flex align-items-center gap-4 flex-wrap">
                  <svg width="150" height="150" viewBox="0 0 42 42" className="flex-shrink-0">
                    <circle cx="21" cy="21" r="15.9" fill="none" stroke="#eef1f8" strokeWidth="6" />
                    {donutSegments.map((s) => (
                      <circle
                        key={s.id}
                        cx="21" cy="21" r="15.9" fill="none"
                        stroke={s.color} strokeWidth="6"
                        strokeDasharray={`${s.pct.toFixed(1)} ${(100 - s.pct).toFixed(1)}`}
                        strokeDashoffset={s.dashoffset.toFixed(1)}
                        strokeLinecap="round"
                        transform="rotate(-90 21 21)"
                      />
                    ))}
                    <text x="21" y="20" textAnchor="middle" fontFamily="Inter" fontSize="6.4" fontWeight="800" fill="#101828">{total}</text>
                    <text x="21" y="25.6" textAnchor="middle" fontSize="3" fill="#8992ab">{t("wr_count_unit")}</text>
                  </svg>

                  <div className="d-flex flex-column gap-3 flex-grow-1" style={{ minWidth: "220px" }}>
                    {donutSegments.length > 0 ? donutSegments.map((s) => (
                      <div className="d-flex align-items-start gap-2" key={s.id}>
                        <span className="rounded-circle flex-shrink-0 mt-1" style={{ width: "9px", height: "9px", backgroundColor: s.color }}></span>
                        <div className="flex-grow-1" style={{ minWidth: 0 }}>
                          <div className="fw-bold text-14 text-dark">{s.label}</div>
                          <div className="text-secondary text-12">{s.desc}</div>
                        </div>
                        <div className="text-end flex-shrink-0">
                          <div className="fw-bold text-14 text-dark" style={{ fontFamily: "Inter" }}>{s.count}</div>
                          <div className="text-secondary text-12" style={{ fontFamily: "Inter" }}>{Math.round(s.pct)}%</div>
                        </div>
                      </div>
                    )) : (
                      <div className="text-secondary text-14">{t("no_data")}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-7">
              <div className="card border-0 rounded-4 shadow-sm p-4 h-100 bg-white">
                <div className="d-flex align-items-baseline justify-content-between mb-1">
                  <h6 className="fw-bold text-dark mb-0">{t("wr_by_category")}</h6>
                  <div className="text-secondary text-12">{total} {t("wr_count_unit")}</div>
                </div>
                <div className="text-secondary text-12 mb-3">{t("wr_by_category_desc")}</div>

                <div className="d-flex flex-column gap-3">
                  {categoryBreakdown.length > 0 ? categoryBreakdown.map((c, idx) => (
                    <div key={c.label}>
                      <div className="d-flex justify-content-between align-items-center text-14 mb-1">
                        <span className="fw-bold text-dark">
                          {c.label}
                          {c.is_uncategorized && (
                            <span className="text-secondary fw-normal text-12 ms-2">{t("uncategorized_hint")}</span>
                          )}
                          {idx === 0 && !c.is_uncategorized && (
                            <span className="badge rounded-2 ms-2 text-10 fw-bold" style={{ backgroundColor: "#fff3d6", color: "#a5680a" }}>
                              {t("highest")}
                            </span>
                          )}
                        </span>
                        <span className="fw-bold" style={{ fontFamily: "Inter" }}>{c.count}</span>
                      </div>
                      <div className="rounded-pill" style={{ height: "11px", backgroundColor: "#eef1f8", overflow: "hidden" }}>
                        <div className="rounded-pill h-100" style={{ width: `${(c.count / categoryMax) * 100}%`, backgroundColor: c.color }}></div>
                      </div>
                    </div>
                  )) : (
                    <div className="text-secondary text-14">{t("no_data")}</div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Row: Top 5 ลูกค้า + SLA */}
          <div className="row g-4 mb-4">
            <div className="col-lg-7">
              <div className="card border-0 rounded-4 shadow-sm p-4 h-100 bg-white">
                <h6 className="fw-bold text-dark mb-1">{t("top5_customers")}</h6>
                <div className="text-secondary text-12 mb-3">{t("top5_customers_desc")}</div>

                <div className="d-flex flex-column gap-1">
                  {topCustomers.length > 0 ? topCustomers.map((c, idx) => (
                    <div className="d-flex align-items-center gap-3 p-2 rounded-3" key={c.uid}>
                      <div
                        className="d-flex align-items-center justify-content-center rounded-3 text-white fw-bold text-12 flex-shrink-0"
                        style={{
                          width: "26px", height: "26px", fontFamily: "Inter",
                          background: idx === 0 ? "linear-gradient(135deg,#ffb020,#f59e0b)"
                            : idx === 1 ? "linear-gradient(135deg,#9fb0d6,#7c8bb0)"
                            : idx === 2 ? "linear-gradient(135deg,#d79b6b,#b97a44)"
                            : "#c7cede",
                        }}
                      >{idx + 1}</div>
                      <div className="flex-grow-1" style={{ minWidth: 0 }}>
                        <div className="fw-bold text-14 text-dark text-truncate">{c.name}</div>
                        <div className="text-secondary text-12 text-truncate">{c.assetLabel}</div>
                        <div className="rounded-pill mt-1" style={{ height: "8px", backgroundColor: "#eef1f8", overflow: "hidden" }}>
                          <div className="rounded-pill h-100" style={{ width: `${(c.count / customerMax) * 100}%`, background: "linear-gradient(90deg,#5b8def,#2f6fed)" }}></div>
                        </div>
                      </div>
                      <div className="fw-bold text-14 text-dark flex-shrink-0" style={{ fontFamily: "Inter" }}>{c.count} {t("wr_count_unit")}</div>
                    </div>
                  )) : (
                    <div className="text-secondary text-14">{t("no_data")}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-lg-5">
              <div className="card border-0 rounded-4 shadow-sm p-4 h-100 bg-white">
                <h6 className="fw-bold text-dark mb-1">{t("sla_response_time")}</h6>
                <div className="text-secondary text-12 mb-3">{t("sla_response_time_desc")}</div>

                <div className="d-flex align-items-center gap-4 flex-wrap">
                  <div className="position-relative flex-shrink-0" style={{ width: "150px", height: "150px" }}>
                    <svg width="150" height="150" viewBox="0 0 42 42">
                      <circle cx="21" cy="21" r="15.9" fill="none" stroke="#fdeceb" strokeWidth="6" />
                      {slaStats.passRate !== null && (
                        <circle
                          cx="21" cy="21" r="15.9" fill="none"
                          stroke="#16a34a" strokeWidth="6"
                          strokeDasharray={`${slaStats.passRate.toFixed(1)} ${(100 - slaStats.passRate).toFixed(1)}`}
                          strokeDashoffset="25"
                          strokeLinecap="round"
                          transform="rotate(-90 21 21)"
                        />
                      )}
                    </svg>
                    <div className="position-absolute top-50 start-50 translate-middle d-flex flex-column align-items-center">
                      <div className="fw-bold" style={{ fontFamily: "Inter", fontSize: "27px", color: "#16a34a" }}>
                        {slaStats.passRate !== null ? `${Math.round(slaStats.passRate)}%` : "-"}
                      </div>
                      <div className="text-secondary text-10">{t("sla_passed")}</div>
                    </div>
                  </div>

                  <div className="flex-grow-1 d-flex flex-column gap-2" style={{ minWidth: "180px" }}>
                    <div className="d-flex align-items-center justify-content-between rounded-3 px-3 py-2" style={{ backgroundColor: "#f6f8fd" }}>
                      <div className="d-flex align-items-center gap-2 text-12 fw-bold text-secondary">
                        <span className="rounded-circle" style={{ width: "8px", height: "8px", backgroundColor: "#16a34a" }}></span>
                        {t("sla_met_within")}
                      </div>
                      <div className="fw-bold" style={{ fontFamily: "Inter", color: "#16a34a" }}>{slaStats.met} {t("wr_count_unit")}</div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between rounded-3 px-3 py-2" style={{ backgroundColor: "#f6f8fd" }}>
                      <div className="d-flex align-items-center gap-2 text-12 fw-bold text-secondary">
                        <span className="rounded-circle" style={{ width: "8px", height: "8px", backgroundColor: "#ef4444" }}></span>
                        {t("sla_exceeded")}
                      </div>
                      <div className="fw-bold" style={{ fontFamily: "Inter", color: "#ef4444" }}>{slaStats.exceeded} {t("wr_count_unit")}</div>
                    </div>
                    <div className="text-secondary text-10 mt-1">
                      {t("sla_avg_response_note")}: <b className="text-dark">{slaStats.avgHours !== null ? `${slaStats.avgHours.toFixed(1)} ${t("sla_unit_hour")}` : "-"}</b>
                      {" · "}{t("sla_target_note")} {SLA_TARGET_HOURS} {t("sla_unit_hour")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}
